import React from 'react';

export function ProfileEmailIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <g
        stroke="#000"
        strokeWidth="1.5"
        clipPath="url(#profile-email-icon-clip)">
        <path d="M16.999 3h-14A2 2 0 0 0 1 5v10a2 2 0 0 0 2 1.999h13.999a2 2 0 0 0 2-2V5a2 2 0 0 0-2-1.999Z" />
        <path strokeLinecap="round" d="m1 6 9 6 8.999-6" />
      </g>
      <defs>
        <clipPath id="profile-email-icon-clip">
          <path fill="#fff" d="M0 0h19.999v19.999H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
